import { z } from 'zod';
import { vehicleSchema } from './vehicle.schema';

export const vehiclePagedCollectionSchema = z.object({
  href: z.string().nullable(),
  offset: z.number(),
  limit: z.number(),
  size: z.number(),
  data: z.array(vehicleSchema),
});
